/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 心電図備考
 */
export type ECGWaveRemarksEnum =
  (typeof ECGWaveRemarksEnum)[keyof typeof ECGWaveRemarksEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ECGWaveRemarksEnum = {
  ST_ELEVATION: 'ST_ELEVATION',
  ST_DEPRESSION: 'ST_DEPRESSION',
  PVC: 'PVC',
  PAC: 'PAC',
  OTHER: 'OTHER',
} as const;
